import { useState } from "react";
import { toastAlert } from "../../utils/AlertContext";
import { postFormatClippingURL } from "../../utils/ConstantsURL";
import { clippingErrorAlert } from "../../utils/clippingErrorAlert";

export const useGenerateIndexClipping = (token, addToDownloadQueue) => {
  const base64ToBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  };

  const [loading, setLoading] = useState(false);

  const generateIndexClipping = async (
    id_documento,
    fecha,
    nombre_documento,
    onClose
  ) => {
    toastAlert("Generando Formato de Índice...", "info");
    if (onClose) onClose();
    setLoading(true);

    try {
      const response = await fetch(postFormatClippingURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          fecha,
          id_documento,
          nombre_documento,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al generar formato de índice");
      }
      const data = await response.json();

      const { content, filename, mimeType } = data.document;
      const blob = base64ToBlob(content, mimeType);
      const url = window.URL.createObjectURL(blob);

      const generatedAt = new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      const currentDate = new Date().toLocaleDateString("en-GB");

      addToDownloadQueue({
        id_documento,
        nameDocument: `Indice_${filename}.pdf`,
        fecha: currentDate,
        generatedAt,
        url,
      });

      toastAlert("Formato de Índice generado y añadido a la cola de descargas", "success");
    } catch (error) {
      toastAlert("Error al generar el Formato de Índice: " + error, "error");
      console.error(error);
      clippingErrorAlert({
        documentName: nombre_documento,
        error: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return { generateIndexClipping, loading };
};
